export const ALL = 0;
export const CUSTOM = 1;
export const NONE = 2;
